<template>
    <div class="ml-24 w-24 relative h-6 relative">
        <div @click="menuVisible = !menuVisible"
             @blur="onBlur"
             class="select-language appearance-none bg-white text-heading font-display text-xl uppercase border-l border-heading h-full w-full box-border cursor-pointer text-left"
             tabindex="0"
        >
            {{ currentLanguage() }}

            <div class="rolldown absolute top-0 bottom-0 flex items-center justify-center">
                <img src="../../assets/img/icons/rolldown.png" alt="">
            </div>
        </div>
        <transition name="expand">
            <div v-show="menuVisible"
                 @focus="menuVisible = true"
                 @blur="menuVisible = false"
                 class="language-menu z-30 bg-white w-24 box-content shadow-md"
            >
                <div class="language-menu-content flex flex-col items-stretch justify-start text-xl w-24">
                    <div v-for="language in languages"
                         @click="setLanguage(language)"
                         :data-active="language === currentLanguage()"
                         class="language-menu-item flex flex-row items-center box-content cursor-pointer hover:bg-selected hover:text-heading relative"
                    >
                        {{ language.toUpperCase() }}

                        <div v-if="language === currentLanguage()" class="checkmark absolute top-0 bottom-0 flex items-center justify-center">
                            <img src="../../assets/img/icons/checkmark.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'LanguageSelect',
    mixins: [Translatable],
    data() {
        return {
            menuVisible: false,
        };
    },
    methods: {
        onBlur() {
			this.menuVisible = false;
        },
        setLanguage(language) {
            this.menuVisible = false;

            if(language !== this.currentLanguage())
                this.$emit('set-language', language);
        },
    },
};

</script>
<style scoped>
.select-language {
    position: absolute;
    top: 0;
    margin: 0;
    padding: 0 0 0 21px;
    line-height: 24px;
    outline: none;
}

.select-language::-moz-focus-inner {
    border: 0;
}

.language-menu {
    position: absolute;
    overflow-y: hidden;
    top: 52px;
    height: 120px;
}

.language-menu-content {
    height: 120px;
    overflow-y: hidden;
}

.language-menu-item {
    height: 60px;
    padding: 0 0 0 21px;
}

.rolldown {
    left: 64px;
}

.checkmark {
    left: 64px;
}

</style>
